import React, { useCallback, useEffect, useState } from "react";
import Header from "../../layouts/Header";
import { axios_instance } from "../../api/axios_instance";
import {
  decryptRequest,
  encryptRequest,
} from "../../utils/encryptdecryptrequest";
import { ToastContainer, toast } from "react-toastify";
import ConfirmBox from "../../layouts/ConfirmBox";

const BankBoxFlags = () => {
  const initialState = {
    allConfig: [{ enable_bank_box: "1", auto_disable_transaction: "1" }],
    activeTab: 0,
    showNavigationModal: false,
    showArrowTopButton: false,
    isChangedData: false,
  };
  const [bankBoxFlagsState, setBankBoxFlagsState] = useState(initialState);

  const initialConfirmBoxState = {
    showConfirmBox: false,
    message: "",
    callFunction: () => {},
  };

  const [confirmBoxState, setConfirmBoxState] = useState(
    initialConfirmBoxState
  );

  const fetchConfigData = useCallback(async () => {
    try {
      const response = await axios_instance({
        url: "/bankbox/getBankBoxTxnConfig",
        method: "GET",
      });

      if (response.status === 200) {
        const allConfig = [
          {
            enable_bank_box: response.data.result[0].enable_bank_box,
            auto_disable_transaction:
              response.data.result[0].auto_disable_transaction,
          },
        ];
        setBankBoxFlagsState((prevState) => ({
          ...prevState,
          allConfig: [...allConfig, ...response.data.result],
          isChangedData: false,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchConfigData();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [fetchConfigData]);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setBankBoxFlagsState((prevState) => ({
        ...prevState,
        showArrowTopButton: true,
      }));
    } else {
      setBankBoxFlagsState((prevState) => ({
        ...prevState,
        showArrowTopButton: false,
      }));
    }
  };

  const handleRadioClick = (e, value, idx) => {
    const { name } = e.target;
    const allConfig = bankBoxFlagsState.allConfig;
    if (name === "enable_bank_box") {
      allConfig.forEach((config, index) => {
        config.enable_bank_box = value;
        config.auto_disable_transaction = value;
        if (index > 0) {
          config.enable_initiate_transaction = value;
          config.enable_verify_transaction = value;
          config.enable_update_transaction = value;
          config.create_file = value;
        }
      });
      return setBankBoxFlagsState({
        ...bankBoxFlagsState,
        allConfig,
        isChangedData: true,
      });
    } else if (name === "auto_disable_transaction") {
      allConfig.forEach((config) => {
        config.auto_disable_transaction = value;
      });
      return setBankBoxFlagsState({
        ...bankBoxFlagsState,
        allConfig,
        isChangedData: true,
      });
    }
    allConfig[idx][name] = value;
    setBankBoxFlagsState({
      ...bankBoxFlagsState,
      allConfig: [...allConfig],
      isChangedData: true,
    });
  };

  const reloadBankBoxConfig = async () => {
    toast.dismiss();
    try {
      const result = await axios_instance({
        url: "/bankbox/reloadBankBoxConfig",
        method: "GET",
      });

      if (result.status === 200) {
        await fetchConfigData();
        toast.success("Details has been saved successfully.", {
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong", { theme: "colored" });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message
          ? error.response.data.msg
          : "Something went wrong",
        { theme: "colored" }
      );
    }
  };

  const submitBankBoxConfig = async () => {
    try {
      const reqData = encryptRequest({
        allConfig: bankBoxFlagsState.allConfig,
        isChangedData: bankBoxFlagsState.isChangedData,
        action: "updateBankBoxConfig",
      });

      const result = await axios_instance({
        url: "/bankbox/updateTransactionConfig",
        method: "POST",
        data: { reqData },
      });
      const decryptedData = decryptRequest(result.data.resData);

      if (result.status === 200) {
        await fetchConfigData();
        toast.success("Details has been saved successfully.", {
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message
          ? error.response.data.message
          : "Something went wrong",
        { theme: "colored" }
      );
    }
  };

  const openConfirmBox = (message, callFunction) => {
    setConfirmBoxState((prevState) => ({
      ...prevState,
      message,
      callFunction,
      showConfirmBox: true,
    }));
  };

  return (
    <span>
      <Header
        isNavigationModal={bankBoxFlagsState.showNavigationModal}
        closeNavigationModal={() =>
          setBankBoxFlagsState({
            ...bankBoxFlagsState,
            showNavigationModal: false,
          })
        }
        openNavigationModal={() =>
          setBankBoxFlagsState({
            ...bankBoxFlagsState,
            showNavigationModal: true,
          })
        }
      ></Header>
      {confirmBoxState.showConfirmBox && (
        <ConfirmBox
          onClick={confirmBoxState.callFunction}
          message={confirmBoxState.message}
          closeModal={() =>
            setConfirmBoxState((prevState) => ({
              ...prevState,
              showConfirmBox: false,
            }))
          }
        ></ConfirmBox>
      )}

      <div className="container-fluid">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="row">
          <div className="main_wrapper">
            <div className="overlay" id="navigation-overly"></div>
            <section className="right_wrapper">
              <div className="panel-white">
                <div className="grayFiltr-bg brdr-FB clearfix">
                  <div className="col-md-12 ">
                    <h3 className="list_title clearfix">
                      Bank Box Flag Configuration
                    </h3>
                  </div>
                </div>

                <div className="container-fluid" id="list_data">
                  <div className="list-box mrg-T20 mrg-B20">
                    <button
                      className="btn rc-btn_primary pad-L20 pad-R20"
                      style={{ float: "right" }}
                      onClick={() =>
                        openConfirmBox(
                          "Would like to Reload BankBox Configuration?",
                          () => reloadBankBoxConfig()
                        )
                      }
                    >
                      <em className="fa fa-refresh"></em> Reload Json Config
                    </button>
                    <div className="fixed-tabnavs filter_flyout dts_tab_navs">
                      <ul className="nav nav-tabs" role="tablist">
                        <li
                          data-input="0"
                          role="presentation"
                          className={`${
                            bankBoxFlagsState.activeTab === 0 ? "active" : ""
                          }`}
                        >
                          <a href="/#">Bank Box Flags</a>
                        </li>
                      </ul>
                    </div>
                    <div className="tab-content ad-fx-cls">
                      <div role="tabpanel" className="tab-pane fade in active">
                        <div>
                          <table
                            className="fmTableview display table table-bordered table-hover"
                            cellSpacing="0"
                            width="100%"
                          >
                            <thead>
                              <tr className="light_row">
                                <th>Transactions</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="bank_box_flag_row">
                                <td>All BankBox Transaction</td>
                                <td>
                                  <div
                                    className="btn-group toggle-option"
                                    data-toggle="buttons"
                                  >
                                    <label
                                      className={`btn tog-btn tog-positive all_bb_txn ${
                                        bankBoxFlagsState.allConfig[0]
                                          .enable_bank_box
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="enable_bank_box"
                                        id="enable_bank_box_yes"
                                        value={
                                          bankBoxFlagsState.allConfig[0]
                                            .enable_bank_box
                                        }
                                        onClick={(e) => handleRadioClick(e, 1)}
                                      />
                                      Enable
                                    </label>
                                    <label
                                      className={`btn tog-btn tog-negative all_bb_txn ${
                                        !bankBoxFlagsState.allConfig[0]
                                          .enable_bank_box
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="enable_bank_box"
                                        id="enable_bank_box_no"
                                        value={
                                          !bankBoxFlagsState.allConfig[0]
                                            .enable_bank_box
                                        }
                                        onClick={(e) => handleRadioClick(e, 0)}
                                      />
                                      Disable
                                    </label>
                                  </div>
                                </td>
                              </tr>

                              <tr className="bank_box_flag_row">
                                <td>Auto Disable BankBox Transaction</td>
                                <td>
                                  <div
                                    className="btn-group toggle-option"
                                    data-toggle="buttons"
                                  >
                                    <label
                                      className={`btn tog-btn tog-positive ${
                                        bankBoxFlagsState.allConfig[0]
                                          .auto_disable_transaction
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="auto_disable_transaction"
                                        id="auto_disable_transaction_yes"
                                        value={
                                          bankBoxFlagsState.allConfig[0]
                                            .auto_disable_transaction
                                        }
                                        onClick={(e) =>
                                          handleRadioClick(e, 1, 0)
                                        }
                                      />
                                      Enable
                                    </label>
                                    <label
                                      className={`btn tog-btn tog-negative ${
                                        !bankBoxFlagsState.allConfig[0]
                                          .auto_disable_transaction
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="auto_disable_transaction"
                                        id="auto_disable_transaction_no"
                                        value={
                                          !bankBoxFlagsState.allConfig[0]
                                            .auto_disable_transaction
                                        }
                                        onClick={(e) =>
                                          handleRadioClick(e, 0, 0)
                                        }
                                      />
                                      Disable
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            </tbody>

                            {bankBoxFlagsState.allConfig.map(
                              (config, index) => {
                                if (index <= 0) {
                                  return (
                                    <React.Fragment
                                      key={index}
                                    ></React.Fragment>
                                  );
                                }

                                // const label = config.payable_account.replace(
                                //   /[^A-Za-z]/g,
                                //   ""
                                // );
                                // const accountType =
                                //   config.account_type === 1
                                //     ? "Float"
                                //     : "Non-Float";

                                return (
                                  <tbody key={index}>
                                    <tr className="bank_box_flag_row">
                                      <th colSpan="3">
                                        {config.account_label}
                                      </th>
                                    </tr>

                                    <tr className="bank_box_flag_row">
                                      <td>Enable Initiate Transaction</td>
                                      <td>
                                        <div
                                          className="btn-group toggle-option"
                                          data-toggle="buttons"
                                        >
                                          <label
                                            className={`btn tog-btn tog-positive ${
                                              config.enable_initiate_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_initiate_transaction"
                                              id="enable_initiate_transaction_yes"
                                              value={
                                                config.enable_initiate_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 1, index)
                                              }
                                            />
                                            Enable
                                          </label>
                                          <label
                                            className={`btn tog-btn tog-negative ${
                                              !config.enable_initiate_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_initiate_transaction"
                                              id="enable_initiate_transaction_no"
                                              value={
                                                !config.enable_initiate_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 0, index)
                                              }
                                            />
                                            Disable
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="bank_box_flag_row">
                                      <td>Enable Verify Transaction</td>
                                      <td>
                                        <div
                                          className="btn-group toggle-option"
                                          data-toggle="buttons"
                                        >
                                          <label
                                            className={`btn tog-btn tog-positive ${
                                              config.enable_verify_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_verify_transaction"
                                              id="enable_verify_transaction_yes"
                                              value={
                                                config.enable_verify_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 1, index)
                                              }
                                            />
                                            Enable
                                          </label>
                                          <label
                                            className={`btn tog-btn tog-negative ${
                                              !config.enable_verify_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_verify_transaction"
                                              id="enable_verify_transaction_no"
                                              value={
                                                !config.enable_verify_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 0, index)
                                              }
                                            />
                                            Disable
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="bank_box_flag_row">
                                      <td>Enable Update Transaction</td>
                                      <td>
                                        <div
                                          className="btn-group toggle-option"
                                          data-toggle="buttons"
                                        >
                                          <label
                                            className={`btn tog-btn tog-positive ${
                                              config.enable_update_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_update_transaction"
                                              id="enable_update_transaction_yes"
                                              value={
                                                config.enable_update_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 1, index)
                                              }
                                            />
                                            Enable
                                          </label>
                                          <label
                                            className={`btn tog-btn tog-negative ${
                                              !config.enable_update_transaction
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="enable_update_transaction"
                                              id="enable_update_transaction_no"
                                              value={
                                                !config.enable_update_transaction
                                              }
                                              onClick={(e) =>
                                                handleRadioClick(e, 0, index)
                                              }
                                            />
                                            Disable
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="bank_box_flag_row">
                                      <td>Create Case File</td>
                                      <td>
                                        <div
                                          className="btn-group toggle-option"
                                          data-toggle="buttons"
                                        >
                                          <label
                                            className={`btn tog-btn tog-positive ${
                                              config.create_file ? "active" : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="create_file"
                                              id="create_file_yes"
                                              value={config.create_file}
                                              onClick={(e) =>
                                                handleRadioClick(e, 1, index)
                                              }
                                            />
                                            Enable
                                          </label>
                                          <label
                                            className={`btn tog-btn tog-negative ${
                                              !config.create_file
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="create_file"
                                              id="create_file_no"
                                              value={config.create_file}
                                              onClick={(e) =>
                                                handleRadioClick(e, 0, index)
                                              }
                                            />
                                            Disable
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="bank_box_flag_row">
                                      <td colSpan="2"></td>
                                    </tr>
                                  </tbody>
                                );
                              }
                            )}

                            <tbody>
                              <tr>
                                <td></td>
                                <td>
                                  <button
                                    className="btn rc-btn_primary"
                                    onClick={() =>
                                      openConfirmBox(
                                        "Would you like to change Bank Box Configuration?",
                                        () => submitBankBoxConfig()
                                      )
                                    }
                                  >
                                    Submit
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="arrowTop">
        {bankBoxFlagsState.showArrowTopButton ? (
          <div className="pageToup">
            <button
              id="go-top"
              onClick={() =>
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
              }
            >
              <span className="fa fa-arrow-up" aria-hidden="true"></span>
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </span>
  );
};

export default BankBoxFlags;
